import { RequestUtil } from "../common";
import { UIHelper } from "./ui-helper";

export class WebPushProvisioningAppleClient {
  prepareWalletDigitalizationUrl: string;
  constructor(
    private apiUrl: string,
    private xIssuerId: string,
    private xUserId: string,
    private token: string,
  ) {
    this.prepareWalletDigitalizationUrl =
      "/api/v1/dcs/cards/prepareWalletDigitization";
    const test = new (window as any).Entrust.EntrustWebPushProvisionning(
      {
        target: document.getElementById("webdisplay-container"),
        issuerId: this.xIssuerId,
        type: "apple",
      },
      (walletOpaqueData: any) => {
        return this.postWebInputInitialization(walletOpaqueData).then(
          (response) => {
            UIHelper.displayMessage(
              "message-container",
              "Get PushOpaqueData " +
                JSON.stringify(walletOpaqueData) +
                " and response " +
                JSON.stringify(response),
              "msg-success",
            );
            return { pushOpaqueData: response.pushOpaqueData };
          },
          (error) => {
            UIHelper.displayMessage(
              "message-container",
              "Error during push provisioning initialization " +
                JSON.stringify(error),
              "msg-error",
            );
            return Promise.reject(error);
          },
        );
      },
      (onResult: any) => {
        UIHelper.displayMessage(
          "message-container",
          "Result " + JSON.stringify(onResult),
          "msg-success",
        );
      },
      (onFailure: any) => {
        UIHelper.displayMessage(
          "message-container",
          "Error " + JSON.stringify(onFailure),
          "msg-error",
        );
      },
      (onCancel: any) => {
        UIHelper.displayMessage(
          "message-container",
          "Cancel " + JSON.stringify(onCancel),
          "msg-error",
        );
      },
    );
  }
  //Send request to the backend in order to init web secure input
  private postWebInputInitialization(walletOpaqueData: any): Promise<any> {
    const prepareWalletDigitizationRequest = {
      walletOpaqueData,
      card: {
        issuerCardId: "4999016789012345ByIssCrdId1234", // See prepareWalletDigitization documentation
      },
    };
    return RequestUtil.putData(
      this.apiUrl + this.prepareWalletDigitalizationUrl,
      prepareWalletDigitizationRequest,
      this.xIssuerId,
      this.xUserId,
      this.token,
      true,
    );
  }
}

export class WebPushProvisioningGoogleClient {
  prepareWalletDigitalizationUrl: string;

  constructor(
    private apiUrl: string,
    private xIssuerId: string,
    private xUserId: string,
    private token: string,
  ) {
    this.prepareWalletDigitalizationUrl =
      "/api/v1/dcs/cards/prepareWalletDigitization";
    const test = new (window as any).Entrust.EntrustWebPushProvisionning(
      {
        target: document.getElementById("webdisplay-container"),
        issuerId: this.xIssuerId,
        type: "google",
      },
      (walletOpaqueData: any) => {
        return this.postWebInputInitialization(walletOpaqueData).then(
          (response) => {
            UIHelper.displayMessage(
              "message-container",
              "Get PushOpaqueData " +
                JSON.stringify(walletOpaqueData) +
                " and response " +
                JSON.stringify(response),
              "msg-success",
            );
            return { pushOpaqueData: response.pushOpaqueData };
          },
          (error) => {
            UIHelper.displayMessage(
              "message-container",
              "Error during push provisioning initialization " +
                JSON.stringify(error),
              "msg-error",
            );
            return Promise.reject(error);
          },
        );
      },
      (onResult: any) => {
        UIHelper.displayMessage(
          "message-container",
          "Result " + JSON.stringify(onResult),
          "msg-success",
        );
      },
      (onFailure: any) => {
        UIHelper.displayMessage(
          "message-container",
          "Error " + JSON.stringify(onFailure),
          "msg-error",
        );
      },
      (onCancel: any) => {
        UIHelper.displayMessage(
          "message-container",
          "Cancel " + JSON.stringify(onCancel),
          "msg-error",
        );
      },
    );
  }

  //Send request to the backend in order to init web secure input
  private postWebInputInitialization(walletOpaqueData: any): Promise<any> {
    const prepareWalletDigitizationRequest = {
      walletOpaqueData,
      card: {
        issuerCardId: "4999016789012345ByIssCrdId1234", // See prepareWalletDigitization documentation
      },
    };
    return RequestUtil.putData(
      this.apiUrl + this.prepareWalletDigitalizationUrl,
      prepareWalletDigitizationRequest,
      this.xIssuerId,
      this.xUserId,
      this.token,
      true,
    );
  }
}
